var _defs, _g, _g2, _g3, _g4, _g5, _line, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCeilingToWindow3Arc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "209px",
    height: "244px",
    viewBox: "0 0 557.2 650",
    enableBackground: "new 0 0 557.2 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 450.5,111.4 460,101.8 0.3,101.8 9.2,111.4 449.2,111.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 69.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    width: 460,
    height: 32.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M129.3,23.8L138.2,2h3.4l8.7,21.9h-3.1l-1.9-4.9h-10.9l-1.9,4.9h-3.2V23.8z M135.2,16.6h9.3l-4.6-11.7 L135.2,16.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M223.6,22.9V1h9.7c1.9,0,3.4,0.5,4.5,1.5c1.1,1.1,1.6,2.3,1.6,4.1c0,1.4-0.4,2.5-1.1,3.3s-1.6,1.5-2.7,1.6 c1.1,0.1,2.2,0.8,3,1.9s1.2,2.2,1.2,3.6c0,1.8-0.5,3.3-1.6,4.2c-1.1,1.1-2.7,1.6-4.6,1.6L223.6,22.9L223.6,22.9z M226.4,10.4h6.6 c1.2,0,2.2-0.3,2.7-1s1-1.5,1-2.5s-0.3-1.9-1-2.6s-1.6-1-2.7-1h-6.6V10.4z M226.4,20.4h6.7c1.2,0,2.2-0.3,3-1 c0.7-0.7,1.1-1.6,1.1-2.7s-0.4-1.9-1.1-2.7s-1.6-1.1-3-1.1h-6.7V20.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M313.3,17.5c-0.5-1.4-0.8-3-0.8-4.6s0.3-3.1,0.8-4.6s1.4-2.6,2.3-3.6c1-1,2.2-1.8,3.6-2.3s2.9-0.8,4.4-0.8 c3.6,0,6.3,1.5,8.3,4.4l-2.2,1.2c-0.7-1-1.5-1.8-2.6-2.3S324.9,4,323.7,4c-2.5,0-4.4,0.8-6,2.5c-1.6,1.6-2.5,3.8-2.5,6.4 c0,1.6,0.4,3.3,1.1,4.6s1.8,2.5,3,3.1c1.2,0.8,2.7,1.1,4.2,1.1c1.2,0,2.3-0.3,3.4-0.8s1.9-1.4,2.6-2.3l2.3,1.2 c-2.2,2.9-4.9,4.4-8.3,4.4c-1.5,0-3-0.3-4.4-0.8s-2.6-1.4-3.6-2.3C314.7,20.1,313.9,18.9,313.3,17.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 321.2,
    y1: 82.6,
    x2: 321.2,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "312.2,85.2 321.2,69.7 330.2,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "312.2,550.1 321.2,565.7 330.2,550.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 230,
    y1: 82.6,
    x2: 230,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "221,85.2 230,69.7 239,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "221,550.1 230,565.7 239,550.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 139.8,
    y1: 82.6,
    x2: 139.8,
    y2: 552.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.9,85.2 139.8,69.7 148.8,85.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.9,550.1 139.8,565.7 148.8,550.1  "
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9678,
    x1: 0,
    y1: 635.2,
    x2: 460,
    y2: 635.2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M471.4,635.9v-15.3h10.1v1.7h-8.1v4.9h8v1.7h-8v7H471.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M486.1,635.9v-15.3h1.9v13.6h7.1v1.7H486.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M500.3,632.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S500.9,633.5,500.3,632.3z M501.3,628.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C501.8,624.9,501.3,626.4,501.3,628.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M520.2,632.3c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S520.8,633.5,520.2,632.3z M521.2,628.3c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C521.7,624.9,521.2,626.4,521.2,628.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M539.8,635.9v-15.3h6.2c1.4,0,2.6,0.4,3.5,1.3c0.9,0.8,1.3,2,1.3,3.4c0,0.7-0.1,1.3-0.3,1.8 c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.3,0.9s-1,0.3-1.5,0.4l4.1,6.2h-2.3l-3.9-6.1h-3.1v6.1H539.8z M541.7,628.1h4 c0.9,0,1.6-0.3,2.2-0.8c0.6-0.5,0.9-1.3,0.9-2.1s-0.3-1.6-0.9-2.1c-0.6-0.5-1.3-0.8-2.2-0.8h-4V628.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCeilingToWindow3Arc);
export default __webpack_public_path__ + "static/media/new_ceiling_to_window_3_arc.40d8363772f9726ac19d39f82b115289.svg";
export { ForwardRef as ReactComponent };